import { Facebook, Instagram, Linkedin, Twitter, Youtube, LogoFooter } from "assets/images";

const MAIN_DOMAIN = "bmhm.org";
const AFFILIATED_DOMAIN = "blackmhmatters.com";

const getAffiliationNotice = (): { label: string; href: string } | null => {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  if (host === MAIN_DOMAIN || host === `www.${MAIN_DOMAIN}`) {
    return {
      label: `Also accessible at ${AFFILIATED_DOMAIN}`,
      href: `https://${AFFILIATED_DOMAIN}`
    };
  }
  if (host === AFFILIATED_DOMAIN || host === `www.${AFFILIATED_DOMAIN}`) {
    return {
      label: `Official site: ${MAIN_DOMAIN}`,
      href: `https://${MAIN_DOMAIN}`
    };
  }
  return null;
};

const ContactInfo = () => {
  const affiliation = getAffiliationNotice();
  const socialMediaIcons = [
    {
      id: 1,
      icon: Facebook,
      url: "https://web.facebook.com/bmhminc"
    },
    {
      id: 2,
      icon: Twitter,
      url: "https://twitter.com/BMHMINC?t=j14EyEHkS9U3H7dB4D7yMQ&s=09"
    },
    {
      id: 3,
      icon: Linkedin,
      url: "https://www.linkedin.com/company/black-mental-health-matters-bmhm"
    },
    {
      id: 4,
      icon: Instagram,
      url: "https://instagram.com/bmhminc"
    },
    {
      id: 5,
      icon: Youtube,
      url: "https://www.youtube.com/channel/UCm7g0xsxaqnoR8lLdLWgfaw"
    }
  ];
  return (
    <div className=" text-gray flex flex-col gap-4 ">
      <a href="/">
        <img src={LogoFooter} alt="logo-footer" height={100} width={100} />
      </a>
      <span className="text-sm md:text-base block hover:text-orange">
        <a href="https://wa.me/12108302610">(210) 830-2610</a>
      </span>
      <span className="text-sm md:text-base block hover:text-orange">
        <a href="mailto:info@bmhm.org">info@bmhm.org</a>
      </span>
      <span className="text-xs md:text-sm text-gray block">
        EIN: 87-2410591
      </span>
      {affiliation && (
        <span className="text-xs md:text-sm block">
          <a
            href={affiliation.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-orange hover:underline"
          >
            {affiliation.label}
          </a>
        </span>
      )}
      <div className="lg:flex gap-4 items-center justify-center hidden">
        {socialMediaIcons.map((icon) => (
          <a key={icon.id} href={icon.url}>
            <img src={icon.icon} className="h-{20} w-{20}" />
          </a>
        ))}
      </div>
      <span className="lg:hidden block  ">
        <p className="text-sm md:text-base">
          {" "}
          © {new Date().getFullYear()} Black Mental Health Matters. All rights reserved.
        </p>
      </span>
    </div>
  );
};

export default ContactInfo;
